// User.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

export const User = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    name: '',
    email: '',
    courseName: '',
    courseCode: '',
    semester: 1,
    profilePic: '',
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`https://pgdost.onrender.com/api/user-profile?email=${localStorage.getItem('email')}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('email')}`,
          },
        });

        const user = response.data;
        setUserData({
          ...user,
          email: user.email,
          password: '',
          confirmPassword: '',
        });
      } catch (error) {
        console.error('Error fetching user profile:', error.response.data.error);
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setUserData({ ...userData, profilePic: reader.result });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put('https://pgdost.onrender.com/api/user-profile', userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('email')}`,
        },
      });

      console.log('User profile updated:', response.data);
      toast.success('Profile Updated Successfully!');
      setTimeout(() => (window.location.href = '/home'), 1000);
    } catch (error) {
      console.error('Error updating user profile:', error.response.data.error);
      toast.error('Error updating profile. Please try again.');
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <form className="bg-white p-8 rounded shadow-md max-w-2xl w-full mx-auto mt-8 rounded-lg">
        <h2 className="text-3xl font-bold mb-6 text-center text-blue-500">User Profile</h2>

        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 font-bold mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={userData.email}
            className="w-full p-3 border rounded bg-gray-100"
            disabled
          />
        </div>

        <div className="mb-4">
          <label htmlFor="name" className="block text-gray-700 font-bold mb-2">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={userData.name}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-4 grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="courseName" className="block text-gray-700 font-bold mb-2">
              Course Name
            </label>
            <input
              type="text"
              id="courseName"
              name="courseName"
              value={userData.courseName}
              onChange={handleChange}
              className="w-full p-3 border rounded"
              required
            />
          </div>
          <div>
            <label htmlFor="courseCode" className="block text-gray-700 font-bold mb-2">
              Course Code
            </label>
            <input
              type="text"
              id="courseCode"
              name="courseCode"
              value={userData.courseCode}
              onChange={handleChange}
              className="w-full p-3 border rounded"
              required
            />
          </div>
        </div>

        <div className="mb-4">
          <label htmlFor="semester" className="block text-gray-700 font-bold mb-2">
            Semester
          </label>
          <input
            type="number"
            id="semester"
            name="semester"
            value={userData.semester}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="profilePic" className="block text-gray-700 font-bold mb-2">
            Profile Image
          </label>
          <input
            type="file"
            id="profilePic"
            name="profilePic"
            onChange={handleFileChange}
            className="w-full p-3 border rounded"
          />
        </div>
        {userData.profilePic && (
          <img
            src={userData.profilePic}
            alt="Profile Preview"
            className="w-full h-auto rounded mb-4"
          />
        )}

        <div className="mb-6">
          <button
            type="submit"
            className="w-full bg-green-500 text-white p-4 rounded hover:bg-green-700"
          >
            Update Profile
          </button>
        </div>
      </form>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};
